import pickAttrs from './pickAttrs';
export function isClosableConfig(closable) {
    return !!closable && typeof closable === 'object';
}
/** Normalize `closable` + `closeIcon` into Dialog/Drawer close-button state. */
export default function getClosable(closable, closeIcon, defaultClosable = true) {
    var _a;
    const config = isClosableConfig(closable) ? closable : null;
    let mergedClosable;
    if (config) {
        mergedClosable = true;
    }
    else if (typeof closable === 'boolean') {
        mergedClosable = closable;
    }
    else if (closeIcon === false || closeIcon === null) {
        mergedClosable = false;
    }
    else {
        mergedClosable = defaultClosable;
    }
    const mergedCloseIcon = (_a = config === null || config === void 0 ? void 0 : config.closeIcon) !== null && _a !== void 0 ? _a : (closeIcon !== false && closeIcon !== null ? closeIcon : undefined);
    return {
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        disabled: !!(config === null || config === void 0 ? void 0 : config.disabled),
        closeBtnProps: config ? pickAttrs(config, { aria: true, data: true }) : {},
    };
}
